import type { LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";

export function preserveFullResetUserInput(
  previousState: LinearConfiguratorState,
  freshState: LinearConfiguratorState,
): LinearConfiguratorState {
  const preservedInput = {
    quantity: previousState.quantity,
    priceReference: previousState.priceReference,
  };

  return {
    ...freshState,
    ...preservedInput,
    previousState: freshState.previousState
      ? {
          ...freshState.previousState,
          ...preservedInput,
        }
      : undefined,
  };
}
